export enum RenovationValueEnum {
	COMPLETE = 1,
	REFRESH = 2,
	ENERGIE = 3,
	TOTALE = 4
}
